<app-menu-bar></app-menu-bar>

<div class="admin-page">
    <div class="admin-container">
        <app-admin-nav></app-admin-nav>

        @if (loading) {
            <p class="state-text">{{ 'admin_loading' | translate }}</p>
        } @else {
            <form class="account-card" [class.shake]="shake" (ngSubmit)="save()" novalidate>
                <h2 class="card-title">{{ 'account_details' | translate }}</h2>

                <div class="field">
                    <label>{{ 'field_username' | translate }}</label>
                    <input class="input readonly" type="text" [value]="username" readonly />
                </div>

                @if (isLocal) {
                    <div class="field">
                        <label>{{ 'field_email' | translate }}</label>
                        <input class="input" [class.invalid]="emailInvalid" type="email" name="email"
                            [(ngModel)]="email" (ngModelChange)="emailInvalid = false" autocomplete="off" />
                        @if (emailInvalid) {
                            <span class="err">{{ 'validation_email_invalid' | translate }}</span>
                        }
                    </div>

                    <div class="field">
                        <label>{{ 'field_name' | translate }}</label>
                        <input class="input" type="text" name="name" [(ngModel)]="name" autocomplete="off" />
                    </div>

                    <div class="field">
                        <label>{{ 'field_mobile' | translate }}</label>
                        <input class="input" type="text" name="mobile" [(ngModel)]="mobile" autocomplete="off" />
                    </div>
                }

                <div class="divider"></div>
                @if (isLocal) {
                    <p class="hint">{{ 'account_password_hint_local' | translate }}</p>
                } @else {
                    <p class="hint">{{ 'account_password_hint_cloud' | translate }}</p>
                }

                <div class="field">
                    <label>{{ (isLocal ? 'account_new_password' : 'field_password') | translate }}</label>
                    <input class="input" [class.invalid]="passwordMismatch" type="password" name="password"
                        [(ngModel)]="password" (ngModelChange)="passwordMismatch = false"
                        autocomplete="new-password" />
                </div>

                <div class="field">
                    <label>{{ 'field_confirm_password' | translate }}</label>
                    <input class="input" [class.invalid]="passwordMismatch" type="password" name="passwordConfirm"
                        [(ngModel)]="passwordConfirm" (ngModelChange)="passwordMismatch = false"
                        autocomplete="new-password" />
                    @if (passwordMismatch) {
                        <span class="err">{{ 'validation_password_mismatch' | translate }}</span>
                    }
                </div>

                <div class="actions">
                    <!-- The label stays in the DOM while saving, hidden, so the pill
                         keeps the width its text gave it; the spinner sits over it.
                         Dropping the label instead collapses the button to a nub, by
                         a different amount in each language. -->
                    <button class="save-btn" type="submit" [disabled]="saving" [class.is-saving]="saving">
                        <span class="save-btn-label">
                            {{ (isLocal ? 'admin_action_save_changes' : 'account_change_password') | translate }}
                        </span>
                        @if (saving) {
                            <span class="save-btn-spinner" aria-hidden="true"></span>
                        }
                    </button>
                </div>
            </form>
        }
    </div>
</div>

<app-footer></app-footer>
